import { ActionReducer } from '@ngrx/store';
import { Action, ActionTypes } from './actions';
import { User } from './models';

export type State = {
  userUpdateSuccess: boolean;
  userUpdateError: string | undefined;

  userStatusChanged: boolean;
  updatingUserStatus: boolean;
  userStatusUpdateError: string | undefined;

  loadingUser: boolean;
  userError: string | undefined;
  selectedUser: User | undefined;

  loadingUsers: boolean;
  usersError: string | undefined;
  userList: User[];
};

export const defaultState: State = {
  userUpdateSuccess: false,
  userUpdateError: undefined,
  userStatusChanged: false,
  updatingUserStatus: false,
  userStatusUpdateError: undefined,

  loadingUser: false,
  userError: undefined,
  selectedUser: undefined,

  loadingUsers: false,
  usersError: undefined,
  userList: [],
};

export const reducer: ActionReducer<State, Action> = (
  state: State = defaultState,
  action: Action,
): State => {
  switch (action.type) {
    case ActionTypes.ClearSelectedUser:
      return { ...state, selectedUser: undefined, userError: undefined };

    case ActionTypes.FetchUsers:
    case ActionTypes.FetchUsersSuccess:
    case ActionTypes.FetchUsersFailure:
      return handleFetchUsersAction(state, action);

    case ActionTypes.CreateUser:
    case ActionTypes.CreateUserSuccess:
    case ActionTypes.CreateUserFailure:
      return handleCreateUserAction(state, action);

    case ActionTypes.UpdateUser:
    case ActionTypes.UpdateUserSuccess:
    case ActionTypes.UpdateUserFailure:
    case ActionTypes.ClearUpdateUser:
      return handleUpdateUserAction(state, action);

    case ActionTypes.EnableUser:
    case ActionTypes.DisableUser:
    case ActionTypes.UserStatusUpdateSuccess:
    case ActionTypes.UserStatusUpdateFailure:
    case ActionTypes.ClearUpdateUserStatus:
      return handleUpdateUserStatusAction(state, action);

    default:
      return state;
  }
};

export function handleFetchUsersAction(state: State, action: Action): State {
  switch (action.type) {
    case ActionTypes.FetchUsers:
      return {
        ...state,
        loadingUsers: true,
        usersError: undefined,
        userList: [],
      };

    case ActionTypes.FetchUsersSuccess:
      return { ...state, loadingUsers: false, userList: [...action.payload] };

    case ActionTypes.FetchUsersFailure:
      return {
        ...state,
        loadingUsers: false,
        usersError: action.error.error.message || action.error.message,
      };
  }
}

export function handleCreateUserAction(state: State, action: Action): State {
  switch (action.type) {
    case ActionTypes.CreateUser:
      return {
        ...state,
        loadingUser: true,
        selectedUser: undefined,
        userError: undefined,
      };

    // TODO: this should be sorting;
    // that is the responsibility of the selector. you numbnut
    case ActionTypes.CreateUserSuccess:
      const newUserList = [...state.userList, { ...action.payload }];
      newUserList.sort((a, b) => {
        if (a.lastName < b.lastName) return -1;
        if (a.lastName > b.lastName) return 1;
        return 0;
      });

      return {
        ...state,
        loadingUser: false,
        selectedUser: { ...action.payload },
        userList: newUserList,
      };

    case ActionTypes.CreateUserFailure:
      return {
        ...state,
        loadingUser: false,
        selectedUser: undefined,
        userError: action.error.error.message,
      };
  }
}

export function handleUpdateUserAction(state: State, action: Action): State {
  switch (action.type) {
    case ActionTypes.UpdateUserSuccess:
      return {
        ...state,
        userUpdateSuccess: true,
        userUpdateError: undefined,
      };

    case ActionTypes.UpdateUserFailure:
      return {
        ...state,
        userUpdateSuccess: false,
        userUpdateError: action.error.error.message || action.error.message,
      };

    case ActionTypes.ClearUpdateUser:
      return {
        ...state,
        userUpdateSuccess: false,
        userUpdateError: undefined,
      };

    default:
      return state;
  }
}

export function handleUpdateUserStatusAction(
  state: State,
  action: Action,
): State {
  switch (action.type) {
    case ActionTypes.EnableUser:
      return {
        ...state,
        updatingUserStatus: true,
        userStatusUpdateError: undefined,
      };

    case ActionTypes.DisableUser:
      return {
        ...state,
        updatingUserStatus: true,
        userStatusUpdateError: undefined,
      };

    case ActionTypes.UserStatusUpdateSuccess:
      return {
        ...state,
        userStatusChanged: true,
        updatingUserStatus: false,
        userStatusUpdateError: undefined,
      };

    case ActionTypes.UserStatusUpdateFailure:
      return {
        ...state,
        userStatusChanged: false,
        updatingUserStatus: false,
        userStatusUpdateError: action.error.message,
      };

    case ActionTypes.ClearUpdateUserStatus:
      return {
        ...state,
        userStatusChanged: false,
        updatingUserStatus: false,
        userStatusUpdateError: undefined,
      };

    default:
      return state;
  }
}

export default reducer;
